// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SendOutlinedSvg from "@fishx/icons-svg/es/asn/SendOutlined";
import FishxIcon from '../components/FishxIcon';

var SendOutlined = function SendOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SendOutlinedSvg
  }));
};

SendOutlined.displayName = 'SendOutlined';
export default React.forwardRef(SendOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SendOutlined.js
// module id = 4081
// module chunks = 0